module.exports = __webpack_public_path__ + "static/media/Litepaper.918a4b2c.pdf";